export class SettingsModel {
    id: any
    key: string = ''
    value: string = ''
    info: string = ''
}